export default "__VITE_ASSET__Dqv8Th4I__"